import { connect } from 'react-redux';

import { IUndergroundTravelProps, UndergroundTravel } from './index';
import { IAppState } from '../../../../common/state';

type TStateProps = Pick<IUndergroundTravelProps, 'travelTime' | 'travelType'>;
type TOwnProps = Pick<IUndergroundTravelProps, 'onDelete'>;

export const UndergroundTravelContainer = connect<TStateProps, null, TOwnProps>((state: IAppState): TStateProps => {
  const jsonQuery = (state.filters.backup && state.filters.backup.jsonQuery) || state.filters.jsonQuery;

  return {
    travelType: jsonQuery.only_foot && jsonQuery.only_foot.value,
    travelTime: jsonQuery.foot_min && jsonQuery.foot_min.value.lte,
  };
})(UndergroundTravel);
